<template>
<div class="mt-4">
    <v-toolbar flat color="white">
        <v-btn color="primary" round class="white--text" @click="addItem()">
            <v-icon>add_circle_outline</v-icon> New
        </v-btn>
        <v-spacer></v-spacer>
        <v-text-field clearable label="Search" v-model="search"></v-text-field>
    </v-toolbar>
    <v-data-table :loading="isLoading" :rows-per-page-items="[25, 50, 100]" :search="search" :items="billing" :headers="headers" disable-initial-sort style="cursor: pointer">
        <template v-slot:items="props">
            <td class="text-xs-center">
                <v-layout justify-center>
                    <v-icon @click="editItem(props.item)">edit</v-icon>
                    <v-icon @click="deleteItem(props.item)">delete</v-icon>
                </v-layout>
            </td>
            <td class="text-xs-center">{{props.item.customerOrganisation.name}}</td>
            <td class="text-xs-center"><v-chip>{{props.item.invoiceLineItems.length}}</v-chip></td>

            <td class="text-xs-center">{{props.item.total | currency}}</td>

            <!-- <td class="text-xs-center">
                <v-icon color="green" v-if="props.item.includeInMonthlyBilling">check_circle_outline</v-icon>
                <v-icon color="red" v-else>cancel</v-icon>
            </td> -->

            <td class="text-xs-center">
                <v-icon v-if="props.item.includeInMonthlyBilling" color="green">check_circle_outline</v-icon>
                <v-icon v-else color="red">cancel</v-icon>
            </td>
            <td class="text-xs-center">{{props.item.startDate}}</td>

            <td class="text-xs-center">{{props.item.endDate}}</td>


        </template>
    </v-data-table>

    <v-dialog v-model="showModal" persistent width="1000px">
        <v-card v-if="item">
            <v-toolbar flat color="primary">
                <v-toolbar-title style="color: white">
                    {{item.modalType}} Billing Item
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="item.modalType=='Add'" :disabled="!item.taxType||!item.customerOrganisationId||
                (!item.includeInMonthlyBilling&&!item.dueDay||!item.paymentTerm)
                " color="white" flat @click="createItem()">Save</v-btn>
                <v-btn v-else-if="item.modalType=='Edit'" :disabled="!item.taxType||!item.customerOrganisationId||
                (!item.includeInMonthlyBilling&&!item.dueDay||!item.paymentTerm)
                " color="white" flat @click="updateItem()">Save</v-btn>
                <v-btn flat color="white" @click="showModal=false, item={}">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout wrap justify-center>
                    <v-flex xs12 md3 mx-1>
                        <v-autocomplete ref="customerOrganisation" v-on:blur="$refs['customerOrganisation'].blur()" item-text="name" item-value="organisationId" :items="customerOrganisations" label="Customer" return-object @change="setOrg()" v-model="item.customerOrganisation" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 md3 mx-1>
                        <v-autocomplete ref="accountingContact" :disabled="!item.customerOrganisation||item.xeroContactId" v-on:blur="$refs['accountingContact'].blur()" item-text="name" item-value="id" :items="accountingContacts" label="Accounting Customer" v-model="item.xeroContactId" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 md3 mx-1>
                        <v-checkbox label="Include in ISP Billing" v-model="item.includeInMonthlyBilling"></v-checkbox>
                    </v-flex>
                    <v-flex xs12 md3 mx-1 v-if="!item.includeInMonthlyBilling">
                        <v-select label="Frequency" v-model="item.frequency" :items="['Monthly', 'Weekly']"></v-select>
                    </v-flex>

                    <v-flex xs12 md3 mx-1>
                        <v-menu :close-on-content-click="false">
                            <v-text-field :value="item.startDate" slot="activator" required label="Start Date*" prepend-icon="date_range"></v-text-field>
                            <v-date-picker :min="today" v-model="item.startDate"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 md3 mx-1>
                        <v-menu :close-on-content-click="false">
                            <v-text-field :value="item.endDate" clearable slot="activator" required label="End Date" prepend-icon="date_range"></v-text-field>
                            <v-date-picker :min="item.startDate" v-model="item.endDate"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 md3 mx-1 v-if="!item.includeInMonthlyBilling">
                        <v-text-field type="number" label="Due Day*" v-model="item.dueDay"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md3 mx-1 v-if="!item.includeInMonthlyBilling">
                        <v-select :items="paymentTerms" label="Payment Term" item-text="name" item-value="value" v-model="item.paymentTerm"></v-select>
                    </v-flex>
                    <v-flex xs12 md3 mx-1>
                        <v-select :items="taxTypes" item-text="name" item-value="taxType" v-model="item.taxType" label="Tax*"></v-select>
                    </v-flex>

                    <v-flex xs12 class="text-xs-center">
                        <h3>Line Items</h3>

                        <v-data-table :items="item.invoiceLineItems" :headers="invoiceHeaders">
                            <template v-slot:items="props">
                                <td>
                                    <v-layout justify-center>
                                        <v-icon @click="editLineItem(props.item)">edit</v-icon>
                                        <v-icon @click="deleteInvoiceLineItem(props.item)">delete</v-icon>
                                    </v-layout>
                                </td>
                                <td class="text-xs-center">
                                    {{props.item.accountType}}
                                </td>
                                <td class="text-xs-center">
                                    <span v-if="props.item.accountType=='Account'">
                                        {{getAccount(props.item.accountCode)}}
                                    </span>
                                    <span v-else>
                                        {{getItem(props.item.accountCode)}}
                                    </span>

                                </td>
                                <td class="text-xs-center">
                                    {{props.item.description}}
                                </td>
                                <td class="text-xs-center">
                                    {{props.item.quantity}}
                                </td>
                                <td class="text-xs-center">
                                    {{props.item.amount | currency}}
                                </td>
                            </template>
                            <template v-slot:footer>

                                <td :colspan="invoiceHeaders.length">
                                    <v-layout justify-center>
                                        <v-btn flat color="blue" @click="addNewLineItem()">
                                            <v-icon class="mx-1" small>add_circle_outline</v-icon> New item
                                        </v-btn>
                                    </v-layout>
                                </td>
                            </template>
                        </v-data-table>
                    </v-flex>
                    <v-flex xs6>
                    </v-flex>
                    <v-flex xs12 md6 v-if="item">
                        <v-layout justify-start wrap>
                            <v-flex xs6 class="text-xs-left">
                                <h3>Subtotal:</h3>
                            </v-flex>
                            <v-flex xs6 class="text-xs-left">
                                <span>{{calculateSubTotal(item) | currency}}</span>
                            </v-flex>
                             <v-flex xs6 class="text-xs-left">
                                <h3>Tax:</h3>
                            </v-flex>
                            <v-flex xs6 class="text-xs-left">
                                <span>{{calculateTaxTotal(item) | currency}}</span>
                            </v-flex>
                             <v-flex xs6 class="text-xs-left">
                                <h3>Total:</h3>
                            </v-flex>
                            <v-flex xs6 class="text-xs-left">
                                <span>{{calculateTotal(item) | currency}}</span>
                            </v-flex>
                        </v-layout>
                    </v-flex>

                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="lineItemModal" width="500px" persistent>
        <v-card v-if="lineItem">
            <v-toolbar flat color="primary">
                <v-toolbar-title class="white--text">
                    {{lineItem.modalType}} Line Item
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn color="white" flat @click="lineItemModal=false,lineItem={}">X</v-btn>
            </v-toolbar>
            <v-card-text>
                <v-layout justify-center wrap>
                    <v-flex xs12 md5 mx-1>
                        <v-select :items="['Item', 'Account']" label="Account Type" v-model="lineItem.accountType"></v-select>
                    </v-flex>
                    <v-flex xs12 md5 mx-1 v-if="accountingAccounts.length>0&&lineItem.accountType=='Account'">
                        <v-autocomplete :items="accountingAccounts" ref="accountingAccounts" v-on:blur="$refs['accountingAccounts'].blur()" item-text="name" item-value="id" v-model="lineItem.accountCode" label="Account*"></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 md5 mx-1 v-else-if="accountingItems.length>0&&lineItem.accountType=='Item'">
                        <v-autocomplete :items="accountingItems" ref="accountingItems" v-on:blur="$refs['accountingItems'].blur()" item-text="name" item-value="id" v-model="lineItem.accountCode" label="Item*"></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 md5 mx-1>
                        <v-text-field type="number" label="Unit Price (excl. VAT)*" v-model="lineItem.amount"></v-text-field>
                    </v-flex>
                    <v-flex xs12 md5 mx-1>
                        <v-text-field type="number" label="Quantity" v-model="lineItem.quantity"></v-text-field>
                    </v-flex>

                    <v-flex xs10>
                        <v-textarea label="Description" v-model="lineItem.description"></v-textarea>
                    </v-flex>
                    <v-flex xs12 class="text-xs-center">
                        <v-btn v-if="lineItem.modalType== 'Edit'" :disabled="!lineItem.accountType||!lineItem.accountCode||!lineItem.amount||!lineItem.quantity||!lineItem.description" round color="primary" class="white--text" @click="updateLineItem()">Save</v-btn>
                        <v-btn v-else-if="lineItem.modalType== 'Add'" :disabled="!lineItem.accountType||!lineItem.accountCode||!lineItem.amount||!lineItem.quantity||!lineItem.description" round color="primary" class="white--text" @click="createLineItem()">Save</v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
export default {
    data() {
        return {
            accountingAccounts: [],
            accountingContacts: [],
            accountingItems: [],
            billing: [],
            customerOrganisations: [],
            taxTypes: [],
            today: new Date().toISOString().substr(0, 10),
            paymentTerms: [{
                    name: 'day(s) after bill date',
                    value: 'DAYSAFTERBILLDATE'
                },
                {
                    name: 'day(s) after bill month',
                    value: 'DAYSAFTERBILLMONTH'
                },
                {
                    name: 'of the current month',
                    value: 'OFCURRENTMONTH'
                },
                {
                    name: 'of the following month',
                    value: 'OFFOLLOWINGMONTH'
                },

            ],
            headers: [{
                    text: "Action",
                    align: "center",
                    sortable: false
                },
                {
                    text: "Customer",
                    align: "center",
                    value: "customerOrganisation.name"
                },
                {
                    text: "Line Items",
                    align: "center",
                    value: "invoiceLineItems.length"
                },
                {
                    text: "Total",
                    align: "center",
                    value: "total"
                },
                
                {
                    text: "Include in ISP Billing",
                    align: "center",
                    value: "includeInMonthlyBilling"
                },
                {
                    text: "Start Date",
                    align: "center",
                    value: "startDate"
                },
                {
                    text: "End Date",
                    align: "center",
                    value: "endDate"
                },
            ],
            invoiceHeaders: [{
                    text: "Action",
                    align: "center",
                    sortable: false
                },
                {
                    text: "Type",
                    align: "center",
                    value: 'type'
                },
                {
                    text: "Account/Item",
                    align: "center",
                    value: 'accountCode'
                },
                {
                    text: "Description",
                    align: "center",
                    value: 'description'
                },
                {
                    text: "Quantity",
                    align: "center",
                    value: 'quantity'
                },
                {
                    text: "Unit Price",
                    align: "center",
                    value: 'unitPrice'
                },
            ],
            item: {},
            isLoading: false,
            search: '',
            showModal: false,
            lineItemModal: false,
            lineItem: {}
        }
    },
    watch: {},
    created() {
        this.fetchAllBilling()
        this.fetchOrganisations()
        this.fetchXeroContacts()
        this.getXeroTaxRates()
        this.fetchXeroAccounts()
        this.fetchXeroItems()
    },
    methods: {
        addNewLineItem() {
            this.lineItem = {
                modalType: 'Add',
                accountType: 'Account',
                accountCode: null,
                quantity: 1,
                amount: 0
            }
            if (this.item.id) {
                this.lineItem.invoiceId = this.item.id
            }
            this.lineItemModal = true
        },
        calculateTaxTotal(obj){
            let tax = 0
            if(obj.taxType){
                tax = this.taxTypes.find(x=>x.taxType == obj.taxType).effectiveRate
            }
            let result = this.calculateSubTotal(obj)*(tax/100)
            return result
        },
        calculateSubTotal(obj){
            let result = obj.invoiceLineItems? obj.invoiceLineItems.reduce((a, b) => +a + +(b.amount*b.quantity), 0): 0
            return result
        },
        calculateTotal(obj){
            return this.calculateSubTotal(obj) + this.calculateTaxTotal(obj)
        },
        editLineItem(item) {
            if (item.id) {
                // Api().put('//invoice/lineItem/' + item.id, item)
                this.lineItem = item
                this.lineItem.index = this.item.invoiceLineItems.indexOf(item)
                this.lineItem.modalType = 'Edit'
            } else {
                this.lineItem = item
                this.lineItem.index = this.item.invoiceLineItems.indexOf(item)
                this.lineItem.modalType = 'Edit'
            }
            this.lineItemModal = true
        },
        addItem() {
            this.item = {
                modalType: 'Add',
                accountType: 'Account',
                startDate: this.today,
                type: 'Infrastructure Billing',
                dueDay: 7,
                paymentTerm: 'OFCURRENTMONTH',
                frequency: 'Monthly',
                includeInMonthlyBilling: true,
                invoiceLineItems: []
            }
            this.showModal = true
        },
        editItem(item) {
            if (this.authUpdate(this.$store.state.currentRoute)) {
                this.item = item
                this.item.customerOrganisation = this.customerOrganisations.find(x => x.organisationId == this.item.customerOrganisationId)
                this.item.modalType = 'Edit'
                this.showModal = true
            }
        },
        deleteItem(item) {
            if (this.authDelete(this.$store.state.currentRoute)) {
                confirm('Are you sure you want to delete this item?') && Api().put('/invoice/infrastructureBilling/' + item.id, {
                    isActive: false,
                    isDeleted: true
                }).then(() => {
                    this.fetchAllBilling()
                })
            }
        },
        deleteInvoiceLineItem(item) {
            if (item.id) {
                if (this.authDelete(this.$store.state.currentRoute)) {
                    confirm('Are you sure you want to delete this item?') && Api().put('/invoice/lineItem/' + item.id, {
                        isActive: false,
                        isDeleted: true
                    }).then(() => {
                        // this.fetchAllBilling()
                        this.item.invoiceLineItems.splice(this.item.invoiceLineItems.indexOf(item), 1)
                    })
                }
            } else {
                this.item.invoiceLineItems.splice(this.item.invoiceLineItems.indexOf(item), 1)
            }

        },
        createItem() {
            if (this.authCreate(this.$store.state.currentRoute)) {
                this.item.subTotal = this.calculateSubTotal(this.item)
                this.item.totalTax = this.calculateTaxTotal(this.item)
                this.item.total = this.calculateTotal(this.item)

                Api().post('/invoice/infrastructureBilling', this.item).then(res => {
                    this.showModal = false
                    this.item = {}
                    this.fetchAllBilling()
                })
            }
        },
        createLineItem() {
            if (this.lineItem.invoiceId) {
                Api().post('/invoice/lineItem', this.lineItem).then((res) => {
                    this.item.invoiceLineItems.push(res.data)
                    this.lineItemModal = false
                    this.lineItem = {}
                })
            } else {
                this.item.invoiceLineItems.push(this.lineItem)
                this.lineItem = {}
                this.lineItemModal = false
            }
        },
        getAccount(code) {
            return this.accountingAccounts.find(x => x.id == code).name
        },
        getItem(code) {
            return this.accountingAccounts.find(x => x.id == code).name
        },
        updateLineItem() {
            if (this.lineItem.id) {
                Api().put('/invoice/lineItem/' + this.lineItem.id, this.lineItem).then(() => {
                    this.item.invoiceLineItems[this.lineItem.index] = this.lineItem
                    this.lineItemModal = false
                    this.lineItem = {}
                })
            } else {
                this.item.invoiceLineItems[this.lineItem.index] = this.lineItem
                this.lineItemModal = false
                this.lineItem = {}
            }
        },
        async fetchXeroAccounts() {
            await Api().get('/xero/accounts').then(res => {
                let result = res.data.body.accounts.filter(x=>x.type=='REVENUE' || x.type=='SALES')
                this.accountingAccounts = result.map(x => ({
                    id: x.code,
                    name: x.name
                }))
            })
        },
        async fetchXeroContacts() {
            await Api().get('/xero/contacts').then(res => {
                let result = res.data.body.contacts
                console.log(result)
                this.accountingContacts = result.map(x => ({
                    id: x.contactID,
                    name: x.name
                }))
                console.log(this.accountingContacts)
            })
        },
        async fetchXeroItems() {
            await Api().get('/xero/items').then(res => {
                let result = res.data.body.items

                this.accountingItems = result.map(x => ({
                    id: x.itemID,
                    name: x.name
                }))
            })
        },
        getXeroTaxRates() {
            Api().get('/xero/taxRates').then(response => {
                if (response.data && response.data.body) {
                    this.taxTypes = response.data.body.taxRates
                    console.log(this.taxTypes)
                }
            })
        },
        updateItem() {
            if (this.authUpdate(this.$store.state.currentRoute)) {
                 this.item.subTotal = this.calculateSubTotal(this.item)
                this.item.totalTax = this.calculateTaxTotal(this.item)
                this.item.total = this.calculateTotal(this.item)
                Api().put('/invoice/infrastructureBilling/' + this.item.id, this.item).then(res => {
                    this.showModal = false
                    this.item = {}
                    this.fetchAllBilling()
                })
            }
        },


        fetchAllBilling() {
            this.isLoading = true
            Api().get('/invoice/infrastructureBilling').then(res => {
                this.billing = res.data
                this.isLoading = false
            })
        },
        fetchOrganisations() {
            this.isLoading = true
            Api()
                .get("/organisationConnection/ispList")
                .then((response) => {
                    this.customerOrganisations = response.data;
                    this.isLoading = false

                });
        },
        getAccountName(item) {
            let result = null
            if (item.accountType == 'Account') {
                let find = this.accountingAccounts.find(x => x.id == item.accountCode)
                if (find) {
                    result = find.name
                }
            } else if (item.accountType == 'Item') {
                let find = this.accountingItems.find(x => x.id == item.accountCode)
                if (find) {
                    result = find.name
                }
            }
            return result
        },
        setOrg() {
            console.log(this.item.customerOrganisation)
            if (this.item.customerOrganisation) {
                this.item.customerOrganisationId = this.item.customerOrganisation.organisationId
                this.item.xeroContactId = this.item.customerOrganisation.accountingId
            } else {
                this.item.xeroContactId = null
            }
        }
    }
}
</script>
